import { createContext, useContext, useState, useEffect } from 'react';
import { nOption } from './ReqShare.js';

export const OptionsContext = createContext();

export const OptionsProvider = ({ children }) => {
  const [optionsData, setOptionsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isFetching, setIsFetching] = useState(false);

  const initOptions = async () => {
    if (isFetching) return;
    setIsFetching(true);

    try {
      const rep = await nOption();
      if (rep?.options) setOptionsData(rep.options);
    } catch (err) {
      setOptionsData(null);
    } finally {
      setIsFetching(false);
      setLoading(false);
    }
  };

  useEffect(() => {
    initOptions();
  }, []);

  return (
    <OptionsContext.Provider value={{ optionsData, setOptionsData, loading }}>
      {children}
    </OptionsContext.Provider>
  );
};

export const useOptions = () => useContext(OptionsContext);
